module.exports = __webpack_public_path__ + "static/img/icon_banner_index.48c5240.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/banner/icon_banner_index.png
// module id = m8Ad
// module chunks = 11